import { useDispatch } from "react-redux";

import React, { useState, useEffect } from "react";
import { addProductReview } from "../redux/features/productReviewSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const AddReview = ({
  showModal,
  handleCloseModal,
  selectedOrderId,
  selectedProductId,
  editMode,
  selectedReview,
}) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();

  // Pre-fill review data when in edit mode
  useEffect(() => {
    if (editMode && selectedReview) {
      setRating(selectedReview.rating);
      setComment(selectedReview.comment);
    } else {
      setRating(0);
      setComment("");
    }
  }, [editMode, selectedReview]);

  // Handle star click
  const handleStarClick = (index) => {
    setRating(index + 1);
  };

  // Handle comment change
  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = () => {
    if (!rating || !comment) {
      toast.error(`${t("Please_provide_a_rating_and_a_comment")}.`, {
        position: "top-right",
        hideProgressBar: true,
        position: 'bottom-right',
        theme: 'dark',

        autoClose: 2000, // Auto close after 2 seconds
      });
      return;
    }

    const reviewData = {
      comments: comment, // Change `comment` to `comments`
      order_id: selectedOrderId, // Change `orderId` to `order_id`
      product_id: selectedProductId, // Change `productId` to `product_id`
      rating,
    };

    dispatch(addProductReview(reviewData))
      .then(() => {
        setRating(0);
        setComment("");
        handleCloseModal();
      })
      .catch((error) => {
        console.error("Failed to submit review:", error);
      });
  };

  return (
    <>
      {/* Conditionally render overlay when modal is open */}
      {showModal && (
        <div className="overlay-custom" onClick={handleCloseModal}></div>
      )}

      <div
        className={`modal fade ${showModal ? "show d-flex align-items-center justify-content-center" : ""
          }`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={!showModal}
        style={{
          display: showModal ? "block" : "none",
          zIndex: 1050, // Ensure modal is above content
        }}
      >
        <div
          className="modal-dialog model-xl"
          style={{
            maxWidth: "800px",
            width: "90%",
          }}
          role="document"
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "0", // Remove border radius
              boxShadow: "0 0 20px rgba(0, 0, 0, 0.8)", // Add blackest shadow
            }}
          >
            <div className="modal-header">
              <h5 className="modal-title">
                {editMode ? "Edit Review" : "Write a Review"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {/* Star Rating Selection */}
              <div className="mb-3">
                <div className="star-rating">
                  {[...Array(5)].map((_, index) => (
                    <span
                      key={index}
                      onClick={() => handleStarClick(index)}
                      style={{
                        cursor: "pointer",
                        color: index < rating ? "#FFD700" : "#ccc", // Gold if filled, gray if not
                        fontSize: "24px",
                      }}
                    >
                      ★
                    </span>
                  ))}
                </div>
              </div>

              {/* Comment Input */}
              <div className="mb-3">
                <textarea
                  className="form-control"
                  value={comment}
                  onChange={handleCommentChange}
                  placeholder="Write your review..."
                  rows="5"
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                {editMode ? "Update Review" : "Submit Review"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddReview;
